export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.tags': 'Tags',
  'menu.comics': 'Comics',
  'menu.comics.list': 'Comic List',
  'menu.comics.recommended': 'Home Recommended',
  'menu.comics.create': 'Create Comic',
  'menu.comics.edit': 'Edit Comic',
  'menu.comics.chapters': 'Chapters',
  'menu.comics.chapterEdit': 'Edit Chapter',
  'menu.logs': 'Logs',
  'menu.logs.blacklist': 'Blacklist',
  'menu.logs.whitelist': 'Whitelist',
  'menu.logs.accessLog': 'Access Log',
  'menu.logs.sourceDevices': 'Source Devices',
  'menu.auditConfig': 'Version Rules',
  'menu.growthConfig': 'Growth Config',
  'menu.applications': 'Applications',
  'menu.apple-subscriptions': 'Apple Subscriptions',
  'menu.console': 'Console',
  'menu.gray-routes': 'Gray Routes',
  'menu.apple-notification-logs': 'Apple Notification Logs',
  'menu.apple-event-rules': 'Apple Event Rules',
  'menu.platform-dispatch-logs': 'Platform Dispatch Logs',
  'menu.client-request-logs': 'Client Request Logs',
  'menu.apple-notification-simulator': 'Simulator',
  'menu.console.gray-routes': 'Gray Routes',
  'menu.console.apple-notification-logs': 'Apple Notification Logs',
  'menu.console.apple-event-rules': 'Apple Event Rules',
  'menu.console.platform-dispatch-logs': 'Platform Dispatch Logs',
  'menu.console.client-request-logs': 'Client Request Logs',
  'menu.console.apple-notification-simulator': 'Simulator',
  'menu.proxy-services': 'Proxy Services',
  'menu.currency-rates': 'Currency Rates',
};
